import Vue from "vue";
import auth from "@/auth/auth.js";
import VueCookie from "vue-cookie";

const state = {
  user: {},
  authUser: {},
  token: null
};

const getters = {};

const actions = {
  LOGIN: function({ commit }, payload) {
    return Vue.prototype.$axios
      .post(
        "/auth/token",
        {},
        {
          auth: {
            username: payload.email,
            password: payload.password
          }
        }
      )
      .then(
        response => {
          auth
            .setToken(response.data.token, response.data.expiry)
            .then(data => {
              if (auth.tokenIsValid(response.data.token)) {
                VueCookie.set("token", response.data.token);
                Vue.prototype.$axios.defaults.headers.common.Authorization = `Bearer ${VueCookie.get(
                  "token"
                )}`;
                commit("SET_USER", auth.decodeToken(response.data.token));
                return response;
              }
              throw new Error("Token is invalid");
            });
        },
        err => {
          throw new Error(err);
        }
      );
  },
  LOAD_AUTH_USER: async function({ commit, state }, payload) {
    return Vue.prototype.$axios.get("/users/" + state.user.uid).then(
      res => {
        commit("SET_AUTH_USER", res.data.user);
      },
      err => {
        throw new Error(err.response.data);
      }
    );
  }
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_AUTH_USER(state, user) {
    state.authUser = user;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
